module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/59af064655a1e9f0de5c6fada0b68db5.svg";